import Glide from '@glidejs/glide'

import '@glidejs/glide/dist/css/glide.core.min.css'
import '@glidejs/glide/dist/css/glide.theme.min.css'

if (!document.querySelector('#carousel-hero')) {
  return
}

const glide = new Glide('#carousel-hero', {
  perView: 1,
  gap: 0,
})

glide.on('run.after', (e) => {
  if (glide.index > 0) {
    document.querySelector('#header').classList.add('bg-brand-purple-300')
  } else {
    document.querySelector('#header').classList.remove('bg-brand-purple-300')
  }
})

glide.mount()
